$(function() {
const $window = $(window);

const $sliderTestimonial = $('.slider-testimonial');

		$sliderTestimonial.each(function() {
			const $this = $(this);

				if (!$this.hasClass('slick-initialized')) {
					$this.slick({
						slidesToShow: 1,
						infinite: true,
					});
				}
			
		});

});